import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=c32f2ef2&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=c32f2ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32f2ef2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c32f2ef2')) {
      api.createRecord('c32f2ef2', component.options)
    } else {
      api.reload('c32f2ef2', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=c32f2ef2&scoped=true&", function () {
      api.rerender('c32f2ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RmR2VfPmcnHT/JS/comp/DocBox.vue"
export default component.exports